import gql from 'graphql-tag'

export default gql`mutation ($user_id: Int!, $user_role_id: Int!, $active_from: String!){
  checkTimesheetsAfterUserRoleChange(user_id: $user_id, user_role_id: $user_role_id, active_from: $active_from)
}`